import { fillAssetFinanceFinanceProposal } from '__core/shared/util/salestrekker';
import template from './lenderAndProductQuickQuote.template.html';

export default {
  template,
  bindings: {
    formName: '<',
    quickQuoteAssetDetails: '<',
    quickQuoteFinanceProposal: '<',
    quickQuoteSearchFields: '<',
    quickQuoteSelectedProduct: '<',
    contacts: '<',
    income: '<',
    expenses: '<',
    assets: '<',
    liabilities: '<',
    ticketClientTypes: '<',
    lenders: '<',
    documents: '<',
    objectives: '<',
    workflow: '<',
    idTicket: '<',
    isDealOwnerBroker: '<',
    isQuickQuoteUnsecured: '<',
    isCommercial: '<',
    isSearchStarted: '<',
    isSearchReset: '<',
    isTicketSettled: '<',
    onSearchFinished: '&',
    onFinished: '&'
  },
  controller: class controller {
    constructor(
      $rootScope,
      $mdUtil,
      $mdMedia,
      helperService,
      assetFinanceService,
      AssetFinanceSearchProduct,
      Product,
      productsService,
      financesService,
      eventService
    ) {
      'ngInject';

      const ctrl = this;
      ctrl.mdMedia = $mdMedia;
      ctrl.currentOrganization = $rootScope.CurrentOrganization;
      ctrl.currentCurrency = $rootScope.CurrentCurrency();
      ctrl.organizationCountry = '';
      ctrl.availableLoanTypes = [];
      ctrl.availableProducts = [];
      ctrl.products = [];
      ctrl.searchProductParams = {};
      ctrl.searchStarted = false;
      ctrl.showSearchResult = false;
      ctrl.showSearch = true;
      ctrl.isReady = false;

      ctrl.initialize = () => {
        ctrl.organizationCountry = helperService.getOrganizationCountry().name;
        ctrl.quickQuoteAssetDetails = ctrl.quickQuoteAssetDetails || [];
        ctrl.quickQuoteFinanceProposal = ctrl.quickQuoteFinanceProposal || {};
        ctrl.quickQuoteSelectedProduct = ctrl.quickQuoteSelectedProduct || [];
        ctrl.contacts = ctrl.contacts || [];
        ctrl.personContacts = _.filter(ctrl.contacts, (c) => !c?.isCompany);
        ctrl.income = ctrl.income || [];
        ctrl.expenses = ctrl.expenses || [];
        ctrl.assets = ctrl.assets || [];
        ctrl.liabilities = ctrl.liabilities || [];
        ctrl.ticketClientTypes = ctrl.ticketClientTypes || [];
        ctrl.lenders = _.chain(ctrl.lenders).sortNatural('name').value();
        ctrl.documents = ctrl.documents || [];
        ctrl.objectives = ctrl.objectives || {};
        ctrl.workflow = ctrl.workflow || {};
        ctrl.idTicket = ctrl.idTicket || '';
        ctrl.searchProductParams = ctrl.searchProductParams || {};
        ctrl.isDealOwnerBroker = ctrl.isDealOwnerBroker || false;
        ctrl.isQuickQuoteUnsecured = ctrl.isQuickQuoteUnsecured || false;
        ctrl.isCommercial = ctrl.isCommercial || false;
        ctrl.isTicketSettled = ctrl.isTicketSettled || false;
        ctrl.isTicketSettled = ctrl.isTicketSettled || false;
        ctrl.availableAssetTypes = assetFinanceService.getAvailableAssetTypes(
          ctrl.isCommercial,
          true
        );
        ctrl.availableLoanTypes = assetFinanceService.getAvailableLoanTypes(ctrl.isCommercial);
        ctrl.totalAssetCost = _.reduce(
          ctrl.assetDetails,
          (memo, num) => memo + helperService.isNumber(num.cost, false),
          0
        );
        ctrl.chosenProducts = [];
        if (ctrl.quickQuoteSelectedProduct?.length) {
          ctrl.chosenProducts.push(Product.Build(ctrl.quickQuoteSelectedProduct[0]));
        }
        ctrl.isReady = true;
      };

      ctrl.changeSearchParams = () => {
        ctrl.availableProducts = [];
      };

      ctrl.searchStart = ({ isSearchStarted }) => {
        productsService.clearCache();
        if (!isSearchStarted) {
          ctrl.changeSearchParams();
          ctrl.searchStarted = true;
          ctrl.showSearchResult = false;
        }

        if (!ctrl.idTicket) {
          ctrl.searchProductParams = {
            assetFinance: {
              quickQuoteAssetDetails: ctrl.quickQuoteAssetDetails || [],
              quickQuoteFinanceProposal: ctrl.quickQuoteFinanceProposal || {},
              quickQuoteSearchFields: ctrl.quickQuoteSearchFields || {},
              quickQuoteSelectedProduct: ctrl.quickQuoteSelectedProduct || [],
              isCommercial: ctrl.isCommercial || false
            }
          };
        }

        financesService
          .assetFinanceProductsSearch({
            idTicket: ctrl.idTicket,
            searchProductParams: ctrl.searchProductParams,
            offsetNo: ctrl.availableProducts?.length,
            isQuote: true
          })
          .then((data) => {
            if (data?.status) {
              const products = [];
              for (let p = 0; p < data?.products?.length; p += 1) {
                products.push(Product.Build(data?.products[p]));
              }
              ctrl.availableProducts = ctrl.availableProducts.concat(products);
              if (!isSearchStarted) {
                ctrl.products = [];
                ctrl.showSearchResult = true;
                ctrl.searchStarted = false;
              }
              ctrl.onSearchFinished({ isSearchStarted: false });
              ctrl.isLoadingFinished = products?.length === 100;
              ctrl.products = products;
            } else {
              ctrl.onSearchFinished({ isSearchStarted: false });
              ctrl.showSearchResult = true;
              ctrl.searchStarted = false;
            }
            eventService.assetFinanceQuickQuoteProcessing({ isProcessing: false });
          });
      };

      ctrl.searchProducts = () => {
        for (let i = 0; i < ctrl.chosenProducts.length; i += 1) {
          ctrl.chosenProducts[i].isSelected = false;
          ctrl.productAdded(ctrl.chosenProducts[i]);
        }
        ctrl.chosenProducts = [];
        ctrl.searchStart({ isSearchStarted: false });
      };

      ctrl.productSelected = (data) => {
        if (data.isSelected) {
          ctrl.chosenProducts.push(data);
        } else {
          ctrl.chosenProducts = [];
        }
        ctrl.availableProducts = [];
        ctrl.showSearchResult = false;
        ctrl.productAdded(data);
      };

      ctrl.productAdded = (data) => {
        const selectedProduct = JSON.parse(JSON.stringify(data));
        if (data?.isSelected) {
          ctrl.quickQuoteFinanceProposal = fillAssetFinanceFinanceProposal(
            ctrl.quickQuoteFinanceProposal || {},
            selectedProduct?.assetFinanceEstimate[0]?.product || {},
            false,
            true
          );
        }
        delete selectedProduct.residential;
        delete selectedProduct.residentialEstimate;
        delete selectedProduct.homeLoanEstimate;
        delete selectedProduct.assetFinanceEstimate;
        delete selectedProduct.docType;
        delete selectedProduct.isSelected;
        ctrl.quickQuoteSelectedProduct = data?.isSelected ? [selectedProduct] : [];
        ctrl.saveLenderAndProductQuickQuote();
      };

      ctrl.removeProduct = () => {
        ctrl.chosenProducts = [];
        ctrl.quickQuoteSelectedProduct = [];
        ctrl.saveLenderAndProductQuickQuote();
      };

      ctrl.listProductsReady = (list) => {
        ctrl.productsList = list;
      };

      ctrl.getLender = (idLender) => _.find(ctrl.lenders, (l) => l.id === idLender);

      ctrl.getLenderDocument = (idLender) => {
        const doc = _.find(ctrl.documents, (d) =>
          d.lender[0] ? d.lender[0].id === idLender && d.type.indexOf('LOGO') > -1 : undefined
        );
        return doc ? doc.url : '';
      };

      ctrl.saveLenderAndProductQuickQuote = () => {
        const data = {
          quickQuoteSelectedProduct: ctrl.quickQuoteSelectedProduct,
          quickQuoteFinanceProposal: ctrl.quickQuoteFinanceProposal,
          aFCD: 'assetFinanceQuickQuoteFinanceProposal'
        };
        ctrl.onFinished({ data });
      };

      ctrl.$onInit = () => {
        ctrl.initialize();
      };

      ctrl.$onChanges = (changes) => {
        if (changes.isSearchReset && changes.isSearchReset.currentValue) {
          ctrl.availableProducts = [];
          ctrl.showSearchResult = false;
        }
        if (changes.isSearchStarted && changes.isSearchStarted.currentValue) {
          ctrl.searchProducts();
        }
      };
    }
  }
};
